module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-160.2f893f6d.svg";